
import { defineComponent } from 'vue'

export default defineComponent({
  name: 'MobileFilterSheet',
  data() {
    return {
      isOpen: false
    }
  },
  methods: {
    open() {
      this.isOpen = true
    }
  },
  watch: {
    isOpen(val: boolean) {
      if (val) {
        document.documentElement.classList.add('overflow-hidden')
        document.body.classList.add('overflow-hidden')
        this.$nextTick(() => {
          (this.$refs.closeBtn as HTMLElement)?.focus()
        })
      } else {
        document.documentElement.classList.remove('overflow-hidden')
        document.body.classList.remove('overflow-hidden')
      }
    }
  },
  beforeDestroy() {
    document.documentElement.classList.remove('overflow-hidden')
    document.body.classList.remove('overflow-hidden')
  }
})
